var swiper = new Swiper('.pop-slider-container', {
  spaceBetween: 10,
  navigation: {
    nextEl: '.swiper-next',
    prevEl: '.swiper-prev',
  },
  breakpoints: {
    0: {
      slidesPerView: 'auto',
      centeredSlides: true
    },
    768: {
      slidesPerView: 2.5,
      centeredSlides: false,
    },
  },
});

document.querySelectorAll('.pop-slider-container .swiper-slide').forEach((slide) => {
  let front = slide.querySelector('.pop-slider-card-front');
  let back = slide.querySelector('.pop-slider-card-back');
  let backATC = slide.querySelector('.pop-slider-back-atc');
  let isClickedFlag = false;

  slide.addEventListener('mouseover', (e) => {
    if (isClickedFlag) return;
    if (backATC.contains(e.target)) return;

    front.style.webkitTransform = 'rotateY(-180deg)';
    front.style.transform = 'rotateY(-180deg)';
    front.classList.add('flipped');

    back.style.webkitTransform = 'rotateY(-0deg)';
    back.style.transform = 'rotateY(-0deg)';
    back.classList.add('flipped');
  });

  slide.addEventListener('mouseleave', (e) => {
    if (backATC.contains(e.target)) return;

    if (!front.classList.contains('immutable')) {
      front.style.webkitTransform = 'rotateY(0deg)';
      front.style.transform = 'rotateY(0deg)';
      front.classList.remove('flipped');
    }

    if (!back.classList.contains('immutable')) {
      back.style.webkitTransform = 'rotateY(-180deg)';
      back.style.transform = 'rotateY(-180deg)';
      back.classList.remove('flipped');
    }
    isClickedFlag = false;
  });

  slide.addEventListener('click', (e) => {
    if (backATC.contains(e.target)) return;

    front.classList.toggle('immutable');
    back.classList.toggle('immutable');

    if (front.classList.contains('immutable')) {
      front.style.webkitTransform = 'rotateY(-180deg)';
      front.style.transform = 'rotateY(-180deg)';
      front.classList.add('flipped');
    } else {
      front.style.webkitTransform = 'rotateY(0deg)';
      front.style.transform = 'rotateY(0deg)';
      front.classList.remove('flipped');
    }

    if (back.classList.contains('immutable')) {
      back.style.webkitTransform = 'rotateY(-0deg)';
      back.style.transform = 'rotateY(-0deg)';
      back.classList.add('flipped');
    } else {
      back.style.webkitTransform = 'rotateY(-180deg)';
      back.style.transform = 'rotateY(-180deg)';
      back.classList.remove('flipped');
    }

    isClickedFlag = true;
  });
});

function adjustATCPosition(container, image, button, content, arrow) {
const containerHeight = container.clientHeight;
const containerWidth = container.clientWidth;
const imgNaturalHeight = image.naturalHeight;
const imgNaturalWidth = image.naturalWidth;

const containerAspectRatio = containerWidth / containerHeight;
const imageAspectRatio = imgNaturalWidth / imgNaturalHeight;

let imageHeight, imageWidth;

if(imageAspectRatio > containerAspectRatio){
  imageHeight = containerWidth / imageAspectRatio;
  imageWidth = containerWidth;
} else {
  imageHeight = containerHeight;
  imageWidth = containerHeight * imageAspectRatio;
}

const emptySpace = (containerHeight - imageHeight) / 2;

const bottomExtra = window.innerWidth <= 989 ? 22 : 56;
button.style.bottom = `${emptySpace + bottomExtra}px`;
content.style.width = `${imageWidth * 0.9}px`;

if(emptySpace && emptySpace > arrow.clientHeight) {
  arrow.style.margin = `auto auto ${emptySpace - arrow.clientHeight - 35}px`;
} else if (!emptySpace) {
  console.log("No empty.");
} else {
  arrow.style.margin = `auto auto -64px`;
}
}


document.querySelectorAll('.pop-slider-container .swiper-slide').forEach(card => {
  const container = card.querySelector('.pop-slider-back-container');
  const image = container.querySelector('img');
  const button = container.querySelector(".pop-slider-back-atc");
  const content = container.querySelector(".pop-slider-back-content");
  const arrow = container.closest('.swiper-slide').querySelector('.arrow');
  const verticalBanner = container.closest('.pop-card-slider').querySelector('#parent');
  const verticalBannerChild = verticalBanner.querySelector('#child-1');

  const resizeObserver = new ResizeObserver(() => {

      verticalBannerChild.style.width = `${verticalBanner.clientHeight}px`;

      adjustATCPosition(container, image, button, content, arrow);
  });

  resizeObserver.observe(container);
});

